import styled from 'styled-components';
import { Typography } from '@mui/material';
import { ActionBar, rem } from '@innovyze/stylovyze';

export const Title = styled(Typography)`
	font-style: normal;
	font-weight: 400;
	font-size: 18px;
	line-height: 32px;
	text-align: left;
	color: #272833;
`;

export const StyledHeaderButton = styled('div')`
	float: right;
`;

export const StyledHeaderText = styled.p`
	color: #768d95;
	font-style: normal;
	text-align: right;
`;

export const RightHeader = styled.div`
	display: flex;
	gap: ${rem(16)};
	align-content: center;
	align-items: center;
`;

export const LeftHeader = styled.div`
	display: flex;
`;

export const StyledActionBar = styled(ActionBar)`
	align-content: center;
`;
